import React from 'react';
import { Toast, Button } from 'antd-mobile';
import {post} from '../../utils/request';
import { href } from '../../utils/util';
import api from './api';
import './index.less';

class safetyTrainingCoursesRecord extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
            listData: [],
            statisticsData: {},
            pageSize: 10,
            skipCount: 0,
            count: 0
        };
    }

    // #/safetyTrainingCoursesRecord?app_stoken=xxxx&hoCourseId=xxx&activityCode=${activityCode}
    componentDidMount() {
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                // let viewPort = this.viewPort();
                // if (
                //     viewPort.ios ||
                //     viewPort.iPhone ||
                //     viewPort.iPad
                // ) {
                //     if(window.webkit){
                //         window.webkit.messageHandlers.login.postMessage('');
                //     }
                // } else {
                //     if(window.huilian){
                //         window.huilian.login('');
                //     }
                // }
                Toast.fail('您还未登录，请登录后再操作',999);
                return;
            }
            this.setState({
                urlOps: ops
            },()=>{
                this.getStatistics()
                this.getList()
            });
        }
    }

    // 获取统计
    getStatistics(){
        const {urlOps} = this.state;
        post({
            url: api.statisticsLearningResult + '&app_stoken=' + urlOps.app_stoken, 
            data: {
                activityCode: urlOps.activityCode
            }
        }).then((res) => {
            if(res.result === 'success'){
                let data = res.data
                var min=Math.floor(res.data.duration%3600);
                data.duration = Math.floor(res.data.duration/3600) + "时" + Math.floor(min/60) + "分"+ res.data.duration%60 + "秒";
                this.setState({
                    statisticsData: data,
                })
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取统计失败',1);
        });
    }

    // 获取列表
    getList(){
        const {urlOps, pageSize, skipCount, listData} = this.state;
        post({
            url: api.selectLearningResultList + '&app_stoken=' + urlOps.app_stoken, 
            data: {
                linkType: 'COURSE',
                skipCount: skipCount * pageSize,
                pageSize: 10,
                activityCode: urlOps.activityCode
            }
        }).then((res) => {
            if(res.result === 'success'){
                this.setState({
                    listData: [
                        ...listData,
                        ...res.data,
                    ],
                    count: res.count
                })
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取列表失败',1);
        });
    }

    render() {
        const {urlOps, listData, statisticsData, skipCount, count} = this.state
        return (
            <div className="safetyTrainingCoursesRecordBox">
                <div className="contentBox cg">
                    <div>
                        <div className="cgTitle">学习总课次</div>
                        <b className="cgContent">{statisticsData.times || 0}次</b>
                    </div>
                    <div>
                        <div className="cgTitle">学习总时长</div>
                        <b className="cgContent">{statisticsData.duration}</b>
                    </div>
                </div>
                <div className="contentBox jl">
                    <div className="listBox">
                        {
                            listData.map((item,index)=>{
                                return (
                                    <div key={index}>
                                        <div className="listTitle">
                                            <div className="left">
                                                <b>{item.linkTitle}</b>
                                            </div>
                                            <div className="right" onClick={()=>{
                                                href('/safetyTrainingCoursesIndex?app_stoken='+ urlOps.app_stoken + '&linkCode=' + item.linkCode)
                                            }}>
                                                查看
                                            </div>
                                        </div>
                                        <div className="listTips">
                                            <div className="left">
                                                学习时长
                                            </div>
                                            <div className="right">
                                                {item.duration}s
                                            </div>
                                        </div>
                                        <div className="listTips">
                                            <div className="left">
                                                学习时间
                                            </div>
                                            <div className="right">
                                                {item.gmtCreate}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        listData.length > 0 ? (
                            listData.length < count ? (
                                <div className="moreBten" onClick={()=>{
                                    this.setState({
                                        skipCount: skipCount+1
                                    },()=>{
                                        this.getList()
                                    })
                                }}>
                                    加载更多
                                </div>
                            ) : (
                                <div className="moreBten">
                                    已到底
                                </div>
                            )
                        ) : (
                            <div className="noData">
                                <div>暂无学习记录</div>
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
};

export default safetyTrainingCoursesRecord;


// WEBPACK FOOTER //
// ./src/safetyTrainingCourses/record/index.js